import * as React from 'react';
import { cn } from '@/lib/utils';
export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  TextareaProps & {
    textAreaClassName?: string;
  }
>(({ className, textAreaClassName, ...props }, ref) => {
  return (
    <div
      className={cn(
        'rounded-md border-[1px] border-bordercolor bg-background pl-3 py-2 text-sm ring-offset-background focus:border-[1px] focus:border-focuscolor',
        className
      )}
    >
      <textarea
        className={cn(
          'flex min-h-[30px] resize-none disabled:cursor-not-allowed pr-3 disabled:opacity-50 w-full focus-visible:outline-none',
          textAreaClassName
        )}
        ref={ref}
        {...props}
      />
    </div>
  );
});
Textarea.displayName = 'Textarea';
export { Textarea };
